export enum ReferralStatusEnum {
  RECEIVED = "Received",
  SCREENING = "Screening",
  SHORTLISTED = "Shortlisted",
  INPROGRESS = "InProgress",
  REJECTED = "Rejected",
  HIRED = "Hired",
}